import httpClient from "@/plugins/axios";

export const getUserAcknowledgments = async (targetType, targetId) => {
    const response = await httpClient.get('/v1/acknowledgments/', {
        params: {
            target_type: targetType,
            target_id: targetId
        }
    });
    return response;
};

export const submitAcknowledgment = async (targetType, targetId, version) => {
    const response = await httpClient.post('/v1/acknowledgments/', {
        target_type: targetType,
        target_id: targetId,
        version: version
    });
    return response;
};
